import { useAtomValue } from 'jotai';
import { demoModeAtom, userDataAtom } from '@/global-store';
import {
  getGovernanceAccessLevel,
  type GovernanceArea,
} from '@/guards/governanceAccess';
import { useEffectiveUserRights } from '@/http/queries/useEffectiveUserRights';

export function useGovernanceAccess(area: GovernanceArea) {
  const demoMode = useAtomValue(demoModeAtom);
  const effectiveRights = useEffectiveUserRights();
  const user = useAtomValue(userDataAtom);
  const isPrivileged = demoMode || user?.isAdmin || user?.isSalesAdmin;
  const isLoading = !isPrivileged && effectiveRights === null;
  const accessLevel = getGovernanceAccessLevel({
    area,
    demoMode,
    effectiveRights,
    user,
  });

  return {
    accessLevel,
    canEdit: accessLevel === 'editor',
    hasAccess: accessLevel === 'viewer' || accessLevel === 'editor',
    isLoading,
  };
}
